import angular from 'angular';

import 'bootstrap-additions/dist/bootstrap-additions.css';
import './styles/app-loading.scss';
import './styles/app.scss';

import services from './app/services';
import config from './app/config';
import components from './app/components';
import auth from './app/auth';
import home from './app/home';
import detail from './app/detail';
import reports from './app/reports';
import AxiosService from './app/services/axios.service';

require('angular-strap');
require('angular-strap/dist/angular-strap.tpl');

angular
    .module('app', [
        // Third party dependencies
        require('angular-cookies'),
        require('angular-route'),
        require('angular-translate'),
        require('angular-translate-loader-static-files'),
        'mgcrea.ngStrap',

        // Application specific modules
        services,
        config,
        components,
        auth,
        home,
        detail,
        reports,
    ])
    .run(() => {
        const element = document.getElementById('appLoadingDiv');
        element.parentNode.removeChild(element);
    });

// Bootstrap angular until manifest has been fetched
window.onload = function getManifest() {
    const manifestURL =
        'https://1u31fuekv5.execute-api.eu-west-1.amazonaws.com/prod/manifest';
    window.iofAxios = new AxiosService();

    const appLoadingDiv = document.createElement('div');
    appLoadingDiv.setAttribute('id', 'appLoadingDiv');
    appLoadingDiv.setAttribute('class', 'sb-app-loading-splash');
    appLoadingDiv.innerHTML = 'Loading Scanbox Connect...';
    document.body.appendChild(appLoadingDiv);

    window.iofAxios.http
        .get(manifestURL)
        .then(({ data }) => {
            window.manifest = data;

            // Start Angular
            angular.bootstrap(document.body, ['app']);
        })
        .catch(() => {
            appLoadingDiv.innerHTML = 'Failed to load Scanbox Connect';
        });
};



// WEBPACK FOOTER //
// ./src/app.js